export default "__VITE_ASSET__B1W7qo8o__"